import { isAbasteceBiz } from '@/common/utils/BizUtils'
import { request } from '@/common/utils/request'

// POI正解 String: address => Object: {lng,lat}
export function geoCode(data) {
  return request
    .post({
      url: 'crm.bdapp.common.geoCode',
      data,
    })
    .then(res => {
      return res.data
    })
}

export function gasGeoCode(data) {
  return request
    .post({
      url: 'taxue.gas.bizopp.geoCode',
      data,
    })
    .then(res => {
      return res.data
    })
}
// 反解 {lng,lat} => address
export function reverseGeo(data) {
  return request
    .post({
      url: 'crm.bdapp.index.common.reverseGeo',
      data,
    })
    .then(res => {
      return res.data
    })
}
// 登录
export function getUserInfo(params = {}) {
  params.referer = location.href

  return request.get({
    url: 'common.getUserInfo',
    params,
  })
}
// 获取bizId
export function getUserInfoBrief(params = {}) {
  return request.get({
    url: 'feidian.bdAppUser.getUserInfoBrief',
    params,
  })
}
// 获取默认城市商圈及选项
export function getDefaultArea(params) {
  return request.get({
    url: 'crm.bdapp.index.common.getBdSelectOption',
    params,
  })
}
// 设置地区语言
export function setCountryLocale(data) {
  return request.post({
    url: 'common.updateUserConfig',
    data,
  })
}
// 获取配置
// 接口文档：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=313593815
export function getShopCommonConfig(params) {
  return request.get({
    url: 'crm.bdapp.common.getConfig',
    params,
  })
}
// 获取国家和语言信息
export function getUserAuthCountry(params) {
  return request.get({
    url: 'common.getUserAuthCountry',
    params,
  })
}
// 记录用户选择的区域
export function recordSelectOption(params) {
  return request.post('crm.bdapp.index.common.recordBdSelectOption', {
    data: params,
  })
}
export function getLaunchCityList() {
  return request
    .get({
      url: 'crm.bizopp.getLaunchCityList',
      params: {
        featureNodeKey: 'crm.bizopp.getLaunchCityList',
      },
      // url: 'crm.common.poi.getOpenCityList'
    })
    .then(res => {
      return res.data
    })
}
export function getOpenCityList() {
  return request
    .get({
      url: 'crm.common.poi.getOpenCityList',
    })
    .then(res => {
      return res.data
    })
}

export function checkPoiInfo(params) {
  return request
    .get({
      url: 'crm.bdapp.index.common.checkCityAndPoi',
      params,
    })
    .then(res => {
      return res.data
    })
}
export function checkBizoppNameChange(params) {
  return request
    .get({
      url: 'crm.bdapp.index.common.checkBizoppNameChange',
      params,
    })
    .then(res => {
      return res.data
    })
}
/** 获取审核验重&审核结果 */
export function judgeSimilarAndRepeat(data) {
  if (data.lat) {
    data.lat += ''
  }
  if (data.lng) {
    data.lng += ''
  }
  return request
    .post({
      url: 'crm.bizopp.bizopp.checkBaseInfoRepeat',
      data,
    })
    .then(res => res)
}
/** 获取页面是否处于可编辑状态 */
export function getCommonApplyBaseInfo(params) {
  return request
    .get({
      url: 'crm.bizopp.bizopp.getCommonApplyBaseInfo',
      params,
    })
    .then(res => {
      return res.data
    })
}

export function getCommonConfig(params) {
  return request
    .get({
      url: 'crm.common.getConfig',
      params,
    })
    .then(res => {
      return res.data
    })
}

export function getBDAppUserInfo(params) {
  return request
    .get({
      url: isAbasteceBiz() ? 'feidian.bdAppUser.getAppUserInfo' : 'feidian.bdAppUser.getUserInfo',
      params,
    })
    .then(res => {
      return res.data
    })
}

// 首页金刚位
export function getVajraQuickLink(params) {
  return request
    .get({
      url: 'feidian.quickLink.get',
      params,
    })
    .then(res => {
      return res.data
    })
}

// 首页金刚位点击
export function getClickQuickLink(params) {
  return request
    .post({
      url: 'feidian.quickLink.click',
      params,
    })
    .then(res => {
      return res.data
    })
}
// 是否在灰度白名单
export function getInWhiteList(params) {
  return request
    .get({
      url: 'feidian.common.inWhiteList',
      params,
    })
    .then(res => {
      return res.data
    })
}
// 首页策略位下发
export function getStrategyPos(params) {
  return request
    .get({
      url: 'feidian.commercial.bdapp.getStrategyPos', // 首页commeroffering接口'https://mock.xiaojukeji.com/mock/12854/commercial/bdapp/getStrategyPos', //
      params,
    })
    .then(res => {
      return res.data
    })
}

// 首页策略列表
export function getCommercialList(params) {
  return request
    .get({
      url: 'feidian.commercial.bdapp.getList',
      params,
    })
    .then(res => {
      return res.data
    })
}
